import { ActionTypes as action } from "./action-types";
import agendaService from "../../../api/agendaService";
import { subtractFromDate, setFilterFormData } from "../../../utils/util";

const actions = {
    setLCATab({ commit }, tab) {
        commit(action.SET_LCA_TAB, tab);
    },
    async getLcaFiscalTerms({ commit }, report_type) {
        const res = await agendaService.getLcaFiscalTerms(report_type);
        commit(action.GET_LCA_FISCAL_TERMS, res.data);
        return res.data
    },
    async getLCACompanies({ commit }, project_name) {
        const res = await agendaService.getLCACompanies(project_name);
        commit(action.GET_LCA_COMPANIES, Array.isArray(res.data) ? res.data : JSON.parse(res.data) ?? []);
        return res.data
    },
    async getLCAData({ commit }, payload) {
        const res = await agendaService.getLCAData(payload);
        commit(action.GET_LCA_DATA, Array.isArray(res.data) ? res.data : JSON.parse(res.data)?.flat() ?? []);
        return res.data
    },
    async getConsolidatedLCAData({ commit }, payload) {
        const res = await agendaService.getConsolidatedLCAData(payload);
        commit(action.GET_CONSOLIDATED_LCA_DATA, Array.isArray(res.data) ? res.data : JSON.parse(res.data)?.flat() ?? []);
        return res.data
    },
    async createLCAData({ commit }, payload) {
        const res = await agendaService.createLCAData(payload);
        return res.data
    },
    async createConsolidatedData({ commit }, payload) {
        const res = await agendaService.createConsolidatedData(payload);
        return res.data
    },
    async deleteLCARecords({ commit }, payload) {
        const res = await agendaService.deleteLCARecords(payload);
        return res.data
    },
    setFirstMonthOfYear({ commit }, month) {
        commit(action.SET_FIRST_MONTH_OF_YEAR, month);
    },
    setActiveAgendaUITab({ commit }, tab) {
        commit(action.SET_ACTIVE_AGENDA_UI_TAB, tab);
    },
    async getMeetingByAgendaId({ commit }, data) {
        let { obj, isLoadMore, initial } = data;
        const res = await agendaService.getMeetingByAgendaId(obj, isLoadMore, initial);
        if (initial) commit(action.MEETING_BY_AGENDA, res.data);
        commit(action.NEW_MEETING_BY_AGENDA, res.data);
        return res.data;
    },
    async getAgendaList({ commit }, meetingType = null) {
        const data = await agendaService.getAgendaList(meetingType);
        commit(action.GET_AGENDA_LIST, data);
        return
    },
    async getAgendaById({ commit }, id) {
        const data = await agendaService.getAgendaById(id);
        commit(action.GET_AGENDA_BY_ID, data);
        return data
    },
    async getAgendaValidation({ commit }, id) {
        const data = await agendaService.getAgendaValidation(id);
        return data
    },
    async createAgenda({ dispatch, commit }, data) {
        const result = await agendaService.createAgenda(data);
        return result
    },
    async updateAgenda({ dispatch, commit }, data) {
        const result = await agendaService.updateAgenda(data);
        return result
    },
    async deleteAgenda({ dispatch, commit }, id) {
        const result = await agendaService.deleteAgenda(id);
        return result
    },
    async setMeetingTypeFilterWidth({ commit }, width) {
        commit(action.SET_MEETING_TYPE_FILTER_WIDTH, width);
        return
    },
    setAgendaDurationFilter({ commit }, formData) {
        let agendafilterKey = "agenda_duration_filter#" + localStorage.getItem('tenantId');
        if (formData) {
            formData = setFilterFormData(formData)
            localStorage.setItem(agendafilterKey, JSON.stringify(formData));
        } else if (localStorage.getItem(agendafilterKey) !== null) {
            formData = localStorage.getItem(agendafilterKey)
                ? JSON.parse(localStorage.getItem(agendafilterKey))
                : {};
        } else {
            const start_date = subtractFromDate('month', 1).toISOString().substr(0, 10)
            const end_date = subtractFromDate().toISOString().substr(0, 10)
            formData = { filter_type: 'month', label: 'Past Month', start_date: start_date, end_date: end_date }
        }
        commit(action.SET_AGENDA_DURATION_FILTER, formData);
    },
    async getAgendaListByMeetingType({ commit }, params = null) {
        const data = await agendaService.getAgendaList(params);
        if (!params.is_archived) {
            commit(action.GET_MEETING_TYPE_AGENDA_LIST, data);
        } else {
            commit(action.GET_MEETING_TYPE_AGENDA_LIST_WITH_ARCHIVE, data);
        }
        return
    },
    async getAgendaListWithArchive({ commit }, params = null) {
        const data = await agendaService.getAgendaListWithArchive(params);
        commit(action.GET_MEETING_TYPE_AGENDA_LIST_WITH_ARCHIVE, data);
        return
    },
    async uploadMOMSignatureDocument({ }, data) {
        const result = await agendaService.uploadMOMSignatureDocument(data);
        return result
    },
    async sendMOMSignatureDocumentEmail({ }, data) {
        const result = await agendaService.sendMOMSignatureDocumentEmail(data);
        return result
    },
    async momSignatureDocumentStatus({ }, id) {
        const result = await agendaService.momSignatureDocumentStatus(id);
        return result
    },
    async momSignatureDocumentDownload({ }, params) {
        const result = await agendaService.momSignatureDocumentDownload(params.meetingId, params.filename);
        return result
    },
    async createMeetingChat({ }, formdata) {
        const result = await agendaService.createMeetingChat(formdata);
        return result
    },
    async updateMeetingChat({ }, formdata) {
        const result = await agendaService.updateMeetingChat(formdata);
        return result
    },
    async listMeetingChatsAndComments({ commit, dispatch, rootState }, meetingId) {
        const result = await agendaService.listMeetingChatsAndComments(meetingId);

        // Collect participant IDs from all chats
        const participantIds = Array.isArray(result.data)
            ? result.data.flatMap(chat => Array.isArray(chat.participants) ? chat.participants.map(p => p.id).filter(id => id != null) : [])
            : [];
        // Deduplicate
        const uniqueIds = [...new Set(participantIds.map(id => String(id).trim()))];

        // Determine which IDs are not already in people.userList (ensure people module is loaded)
        const existingUserList = (rootState.people && Array.isArray(rootState.people.userList)) ? rootState.people.userList : [];
        const existingIdsSet = new Set(existingUserList.map(u => String(u.id)));
        const missingIds = uniqueIds.filter(id => !existingIdsSet.has(id));
        if (missingIds.length) {
            // Fetch deleted users (they will be cached/deduped inside the meeting module action)
            const deletedUsers = await dispatch("meeting/getDeletedUsersListTemp", missingIds, { root: true });
            commit(action.AGENDA_MEETING_CHAT, result.data);
            return result;
        } else {
            commit(action.AGENDA_MEETING_CHAT, result.data);
            return result;
        }
    },
    async chatParticipants({ commit }, meetingId) {
        const result = await agendaService.chatParticipants(meetingId);
        commit(action.AGENDA_MEETING_CHAT_PARTICIPANTS, result.data);
        return result
    },
    async meetingChatComment({ }, formdata) {
        const result = await agendaService.meetingChatComment(formdata);
        return result
    },
    async deleteMeetingChat({ }, chatId) {
        const result = await agendaService.deleteMeetingChat(chatId);
        return result
    },
    async listMeetingChatComments({ commit }, chatId) {
        const result = await agendaService.listMeetingChatComments(chatId);
        commit(action.MEETING_CHAT_COMMENTS, result.data);
        return result.data
    },
    async addMeetingMessage({ }, formdata) {
        const result = await agendaService.addMeetingMessage(formdata);
        return result
    },
    async saveChatMessageForm({ }, formdata) {
        const result = await agendaService.saveChatMessageForm(formdata);
        return result
    },
    async updateMeetingMessage({ }, formdata) {
        const result = await agendaService.updateMeetingMessage(formdata);
        return result
    },
    async deletechatmessage({ }, params) {
        const result = await agendaService.deletechatmessage(params);
        return result
    },
    resetState({ commit }) {
        commit(action.RESET_STATE);
    },
    setChatMessages({ commit }, data) {
        commit('setChatMessages', data);
    },
    async getObservers({ commit }, meetingTypeId) {
        const result = await agendaService.getObservers(meetingTypeId);
        commit(action.SIGNATURE_PROVIDER, result.data.e_signature_provider);
        commit(action.OBSERVER_LIST, result.data.obsevers_list);
        return result
    },
};

export default actions;
